// this file is automatically generated by git.version.ts script
export const versions = {revision: 'abcec9da2'};